import React, { useEffect, useState, useCallback, useMemo } from "react";
import "./treatmenttable.scss";
import Treatments from "./components/treatments/Treatments";
import Treatdiagnose from "./components/treatdiagnose/Treatdiagnose";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../../../../../redux/store";
import baseUrl from "../../../../../../api/baseUrl";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../redux/loader/loaderActions";
import AddXray from "./components/addxray/AddXray";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
  addDiagnosesImage,
  addPrescriptions,
  addTreatmentImage,
} from "../../../../../../redux/diagnosestate/diagnoseAction";
import { toast } from "react-toastify";
import AddButton from "../../../../../../components/headers/AddButton";
import TreatmentFormModal from "./components/treatmentform/TreatmentFormModal";
import { io } from "socket.io-client";
import CryptoJS from "crypto-js";
import Container from "../../../../../../layouts/containers/Container";
import AddSubTreatmentModel from "./components/treatments/AddSubTreatmentModel";
import ReportModal from "./components/reportModal/ReportModal";

// Function to decrypt a token
const decryptToken = (token: string, secret: string): string | undefined => {
  try {
    return CryptoJS.AES.decrypt(token, secret).toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting token:", error);
    return undefined;
  }
};

interface ImageData {
  id: string;
  url: string;
  file: any;
  base64: any;
}

function TreatmentTable() {
  const diagnose = useSelector((state: RootState) => state.diagnose);
  const navigate = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const [paymentDetails, setpaymentDetails] = useState<any>({});
  const [allTeatment, setallTeatment] = useState([]);
  const [addTreatmentOpent, setaddTreatmentOpent] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [formData, setFormData] = useState<ImageData[]>([]);

  const fetchData = useCallback(() => {
    if (!ID) return;

    dispatch(setloadeActive());
    baseUrl
      .get("treatment/find-treatment", {
        headers: { treatmentid: ID },
      })
      .then(async (response) => {
        setFormData([]);

        const {
          aditionalNote,
          patientComplain,
          diagnose,
          imageDiagnose,
          imageTreatment,
          prescription,
        } = response.data.data;

        function cleanDoseArray(data: any) {
          return data.map((item: any) => ({
            _id: item?._id || "",
            dose: item?.doseId || "",
            drugsId: item?.drugsId?._id || "",
            drugs: item?.drugsId?.drugs || "",
            type: item?.drugsId?.type || "",
            duration: item?.duration || "",
            frequency: item?.frequency || "",
            createdAt: item?.createdAt || "",
          }));
        }
        dispatch(addPrescriptions(cleanDoseArray(prescription) ?? []));

        dispatch(addAditionalNote(aditionalNote));
        dispatch(addDiagnoseNote(patientComplain));
        dispatch(addDiagnoses(diagnose));
        dispatch(addDiagnosesImage(imageDiagnose));
        dispatch(addTreatmentImage(imageTreatment));
        setallTeatment(response.data.data.treatment);

        let estimate = 0;
        let totals = 0;

        response.data.data.treatment.forEach((item: any) => {
          if (item.status !== "planned") {
            totals += parseFloat(item.price);
          }
          item?.subTreatment?.forEach((subItem: any) => {
            if (
              subItem.selected_option === "treatment_paid" &&
              subItem.status !== "planned"
            ) {
              totals += parseFloat(subItem.price) || 0;
            }
          });
          estimate += parseFloat(item.price);

          item?.subTreatment?.forEach((items: any) => {
            if (items.selected_option === "treatment_paid") {
              estimate += parseFloat(items.price);
            }
          });
        });

        const paymentResponse = await baseUrl.get("payment/last-payment", {
          headers: { treatmentid: ID },
        });

        // setPayment(paymentResponse.data.data);

        let lastDue = 0;
        let lastTotal = 0;
        paymentResponse.data.data.forEach((item: any) => {
          lastDue +=
            parseFloat(item.total) -
            parseFloat(item.discount) -
            parseFloat(item.card) -
            parseFloat(item.bankTransfer) -
            parseFloat(item.cash);
          lastTotal += parseFloat(item.total);
        });

        setpaymentDetails((prevFormData: any) => ({
          ...prevFormData,
          total: totals,
          estimate: estimate,
          outStanding: totals - lastTotal + lastDue,
          paid: lastTotal - lastDue,
        }));
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [ID, dispatch]);

  useEffect(() => {
    fetchData();
  }, [ID, fetchData, addTreatmentOpent]);
  useEffect(() => {
    const calculatePayments = () => {
      let estimate = 0;
      let totals = 0;

      allTeatment.forEach((item: any) => {
        if (item.status !== "planned") {
          totals += parseFloat(item.price) || 0;
        }

        item?.subTreatment?.forEach((subItem: any) => {
          if (
            subItem.selected_option === "treatment_paid" &&
            subItem.status !== "planned"
          ) {
            totals += parseFloat(subItem.price) || 0;
          }
        });

        estimate += parseFloat(item.price) || 0;

        item?.subTreatment?.forEach((subItem: any) => {
          if (subItem.selected_option === "treatment_paid") {
            estimate += parseFloat(subItem.price) || 0;
          }
        });
      });

      setpaymentDetails((prevFormData: any) => ({
        ...prevFormData,
        total: totals,
        estimate: estimate,
        outStanding: totals - (prevFormData.paid || 0),
      }));
    };

    calculatePayments();
  }, [allTeatment]);

  const handleSave = useCallback(() => {
    dispatch(setloadeActive());
    const socket = io(process.env.REACT_APP_WS || "");
    const token = localStorage.getItem("token");
    const secret = process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$";
    const decryptedToken = token ? decryptToken(token, secret) : undefined;
    socket.emit("addedTreatment", decryptedToken);
    if (formData.length > 0) {
      const imagesData = formData.map((imageData) => imageData.base64);
      baseUrl
        .post(
          "treatment/addxraytoTreatement",
          { image: imagesData },
          { headers: { treatmentid: ID } }
        )
        .finally(() => {
          dispatch(setloadeDeactive());
          socket.disconnect();
        });
    } else {
      dispatch(setloadeDeactive());
      toast("Saved");
    }
  }, [dispatch, formData, ID]);

  const handleRemove = useCallback(
    (e: any) => {
      dispatch(setloadeActive());
      baseUrl
        .delete("treatment/remove-TreatmentImage", {
          headers: {
            treatmentid: ID,
            treatmentImageid: e,
          },
        })
        .then(() => fetchData())
        .catch(console.error)
        .finally(() => dispatch(setloadeDeactive()));
    },
    [ID, dispatch, fetchData]
  );

  const openTreatmentModal = () => setaddTreatmentOpent(true);
  const fetch = () => {
    fetchData();
  };

  const payment = useCallback(() => {
    dispatch(setloadeActive());
    if (formData.length > 0) {
      const imagesData = formData.map((imageData) => imageData.base64);
      baseUrl
        .post(
          "treatment/addxraytoTreatement",
          { image: imagesData },
          { headers: { treatmentid: ID } }
        )
        .then(() => navigate(`/client/payments/invoice/${ID}`))
        .catch(console.error)
        .finally(() => dispatch(setloadeDeactive()));
    } else {
      navigate(`/client/payments/invoice/${ID}`);
      dispatch(setloadeDeactive());
    }
  }, [dispatch, formData, ID, navigate]);

  const diagnoseImages = useMemo(() => diagnose.treatmentImage, [diagnose]);
  const [subTreatOpen, setsubTreatOpen] = useState(false);
  const [treatment_id, settreatment_id] = useState("");
  const handleAddSubTreatmentModal = (e: any) => {
    settreatment_id(e);

    setsubTreatOpen((e) => !e);
  };
  return (
    <>
      <div className="space-y-3">
        {/* Diagnosis Table Section */}
       
            <Treatdiagnose adult={true} />
         

        {/* Treatment Table Section */}
        <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
          <div className="px-4 py-2.5 border-b border-slate-200 flex items-center justify-between">
            <h3 className="text-sm font-bold text-slate-800">Treatment Table</h3>
            <button
              onClick={openTreatmentModal}
              className="px-3 py-1.5 rounded-lg bg-indigo-50 hover:bg-indigo-100 text-indigo-600 font-medium text-xs transition-colors"
            >
              + Add Treatment
            </button>
          </div>
          <div className="p-3 overflow-x-auto">
            <Treatments
              allTeatment={allTeatment}
              setallTeatment={setallTeatment}
              handleAddSubTreatmentModal={handleAddSubTreatmentModal}
            />
          </div>
        </div>

        {/* X-Ray Section */}
        <AddXray
          formData={formData}
          setFormData={setFormData}
          apiImage={diagnoseImages}
          handleRemove={handleRemove}
        />

        {/* Payment Summary */}
        <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-4">
          <h4 className="text-xs font-semibold text-slate-700 mb-3">Payment Summary</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="bg-slate-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-slate-500 uppercase tracking-wide">Estimated</p>
              <p className="text-base font-bold text-slate-800">Rs {paymentDetails?.estimate || 0}</p>
            </div>
            <div className="bg-indigo-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-indigo-600 uppercase tracking-wide">Total Bill</p>
              <p className="text-base font-bold text-indigo-700">Rs {paymentDetails?.total || 0}</p>
            </div>
            <div className="bg-emerald-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-emerald-600 uppercase tracking-wide">Paid</p>
              <p className="text-base font-bold text-emerald-700">Rs {paymentDetails?.paid || 0}</p>
            </div>
            <div className={`rounded-lg p-3 text-center ${paymentDetails?.outStanding > 0 ? "bg-red-50" : "bg-emerald-50"}`}>
              <p className={`text-[10px] uppercase tracking-wide ${paymentDetails?.outStanding > 0 ? "text-red-600" : "text-emerald-600"}`}>Outstanding</p>
              <p className={`text-base font-bold ${paymentDetails?.outStanding > 0 ? "text-red-700" : "text-emerald-700"}`}>Rs {paymentDetails?.outStanding || 0}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-2 justify-between">
          <button
            onClick={() => setReportOpen(true)}
            className="px-4 py-2 rounded-lg border border-amber-200 bg-amber-50 text-amber-700 font-medium text-xs hover:bg-amber-100 transition-colors"
          >
            Generate Report
          </button>
          <div className="flex gap-2">
            <button
              onClick={handleSave}
              className="px-4 py-2 rounded-lg border border-slate-200 text-slate-600 font-medium text-xs hover:bg-slate-50 transition-colors"
            >
              Save
            </button>
            <button
              onClick={payment}
              className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium text-xs hover:shadow-lg hover:shadow-primary/20 transition-all"
            >
              Go to Pay
            </button>
          </div>
        </div>
      </div>

      {addTreatmentOpent && (
        <TreatmentFormModal
          treatment={allTeatment}
          setaddTreatmentOpent={setaddTreatmentOpent}
          settreatment={setallTeatment}
          fetchData={fetch}
        />
      )}
      {subTreatOpen && treatment_id !== "" && (
        <AddSubTreatmentModel
          TreatmentId={treatment_id}
          setSubTreatmentOpen={setsubTreatOpen}
          allTeatment={allTeatment}
          setallTeatment={setallTeatment}
        />
      )}
      {reportOpen && <ReportModal setReportOpen={setReportOpen} />}
    </>
  );
}

export default TreatmentTable;
